import { render } from "./EventCard.vue?vue&type=template&id=e9b3bf8a&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=e9b3bf8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e9b3bf8a"

export default script